import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const createContact = async (data: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/contacts`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const contact = await result.json();
  return contact;
};

export default createContact;
